import { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../../../utils/apiConfig';

async function fetchJson(url, token) {
  const res = await fetch(url, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    },
  });
  return res.json();
}

export function useOrderDetailsPedidoPanel(codigoPedido, enabled, native = false) {
  const [pedido, setPedido] = useState(null);
  const [codigo, setCodigo] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cod = String(codigoPedido ?? '').trim();
    if (!enabled || !cod) {
      setPedido(null);
      setTimeline([]);
      setError(null);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setPedido(null);
    setCodigo(null);
    setTimeline([]);

    const token = localStorage.getItem('authToken');
    const base = getApiBaseUrl();
    const qs = native ? '?nativa=1' : '';

    Promise.all([
      fetchJson(`${base}/api/orders/pedido/${encodeURIComponent(cod)}${qs}`, token),
      fetchJson(`${base}/api/orders/pedido/${encodeURIComponent(cod)}/timeline${qs}`, token),
    ])
      .then(([pedidoJson, timelineJson]) => {
        if (cancelled) return;
        setCodigo(native ? null : (pedidoJson?.codigoPedido || null));
        if (pedidoJson?.success && pedidoJson.data) {
          setPedido(pedidoJson.data);
        } else {
          setPedido(null);
          setError(pedidoJson?.message || 'Não foi possível carregar o pedido.');
        }
        if (timelineJson?.success && Array.isArray(timelineJson.data)) {
          setTimeline(timelineJson.data);
        } else {
          setTimeline([]);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPedido(null);
          setTimeline([]);
          setError('Erro ao carregar dados do pedido.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [codigoPedido, enabled, native]);

  const statusAtual = timeline.length > 0 ? timeline[0] : null;

  return { pedido, codigo, timeline, statusAtual, loading, error };
}
